import React from "react";
import {Box} from "@mui/system";
import noSettingImage from "../../assets/img/recommended/noSetting.svg";
import {TextField, Typography} from "@mui/material";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import {useRecommendedContext} from "../../context/recommended/RecommendedContext";
import {COLORS} from "../../ui/Theme";
import {toast} from "react-toastify";
import {ERROR_STATUS} from "../../status/status";
import {sendData} from "../../lib/dashboard/actions";
import {mutate} from "swr";
import {useNavigate, useSearchParams} from "react-router-dom";
import Loading from "../../components/loader/Loading";

const RecommendedAddSetting = () => {
    const {config, configNewName, setConfigNewName} =
        useRecommendedContext();

    const [searchParams] = useSearchParams();

    const navigate = useNavigate();

    //CREATE NEW SETTING NAME FOR FIRST TIME
    const handleAddSettingName = async (e) => {

        e.preventDefault();
        if (!configNewName.trim()) {
            toast(ERROR_STATUS.INPUT, {type: "error"});
            return;
        }
        await sendData({name: configNewName}, "/stock-market/v2/recomm-config");
        await Promise.all([
            mutate("/stock-market/v2/recomm-config"),
            mutate(["/stock-market/recommended", searchParams.toString()])
        ])
        navigate("/dashboard/recommended/setting")
        setConfigNewName("")
    };

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                height: "calc(100vh - 200px)",
                gap: "20px",
            }}
        >
            <img width="300px" src={noSettingImage} alt="settingImage"/>
            <form
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    gap: "20px",
                    width: "358px",
                }}
                onSubmit={handleAddSettingName}
            >
                <Typography sx={{fontSize: "24px", fontWeight: "bold", color: COLORS.BLACK, marginBottom: "60px"}}>
                    اولین تنظیمات خود را بسازید
                </Typography>
                <TextField
                    value={configNewName}
                    onChange={(e) => setConfigNewName(e.target.value)}
                    placeholder="نام تنظیمات"
                />
                <button
                    disabled={config.isValidating}
                    type="submit"
                    style={{
                        justifyContent: "center",
                        cursor: config.isValidating ? "default" : "pointer",
                    }}
                    className="btn btn-blue"
                >
                    {
                        config.isValidating
                            ?
                            <Loading
                                size="11px"
                                color={COLORS.WHITE}
                            />
                            :
                            <>
                                ثبت و ادامه
                                <KeyboardArrowLeftIcon/>
                            </>
                    }
                </button>
            </form>
        </Box>
    );
};

export default RecommendedAddSetting;
